module.exports = __webpack_public_path__ + "img/4.d66d79fa.png";